/* eslint-disable prettier/prettier */
import { Button, Form, Row, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import editInfoIcon from 'assets/images/profilepage-editInfo.svg'
import cancelEditInfoIcon from 'assets/images/profilepage-cancelEditInfo.svg'
import referralCopyIcon from 'assets/images/profilepage-referralCopy.svg'
import modalSuccessIcon from 'assets/images/modal-success.svg'
import modalErrorIcon from 'assets/images/modal-error.svg'
import { useEffect, useRef, useState } from 'react'
import { useUpdateUserInfo } from 'dataLayer/user'
import UnitelModal from 'components/Modal/UnitelModal'
import { getUserinfo, saveUserInfo } from 'utils/localStorage'

function UserInfo({ userData }) {
	const { t } = useTranslation()

	const [infoData, setInfoData] = useState({
		full_name: userData?.displayName,
		phone: userData?.msisdn,
	})
	function handleInfoChange(e) {
		const newInfoData = { ...infoData }
		newInfoData[e.target.id] = e.target.value
		setInfoData(newInfoData)
	}

	const [showSuccess, setShowSuccess] = useState(false)
	const [referralError, setReferralError] = useState('')
	const [showError, setShowError] = useState(false)
	const referralCodeRef = useRef(null)
	function handleCopyReferralCode() {
		const referralCode = referralCodeRef.current.value
		if (window.isSecureContext && navigator.clipboard) {
			navigator.clipboard.writeText(referralCode).then(
				() => {
					if (referralCode == null || referralCode === '') {
						referralErrorAlert()
					} else {
						referralSuccessAlert()
					}
				},
				() => {
					referralErrorAlert()
				},
			)
		} else {
			unsecuredCopyToClipboard(referralCode)
		}
	}
	function unsecuredCopyToClipboard(text) {
		const textArea = document.createElement("textarea"); textArea.value = text; document.body.appendChild(textArea); textArea.focus(); textArea.select();
		try {
			document.execCommand('copy')
			referralSuccessAlert()
		} catch (err) {
			referralErrorAlert()
		} document.body.removeChild(textArea)
	};
	function referralSuccessAlert() {
		setShowError(false)
		setShowSuccess(true)
		setReferralError(t('profile.personal_info.referral_success'))
		setTimeout(() => {
			setShowSuccess(false)
			setShowError(false)
			setReferralError('')
		}, 3000)
	}
	function referralErrorAlert() {
		setShowSuccess(false)
		setShowError(true)
		setReferralError(t('profile.personal_info.referral_error'))
		setTimeout(() => {
			setShowSuccess(false)
			setShowError(false)
			setReferralError('')
		}, 3000)
	}

	const prevInfoUser = useRef()
	useEffect(() => {
		prevInfoUser.current = infoData
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	// TODO: CLick edit auto focus on name input (currently focus() ref is not working)
	const focusInputRef = useRef(null)
	const [isEditInfo, setIsEditInfo] = useState(false)
	function handleEditInfo() {
		setInfoData({ full_name: userData?.displayName, phone: userData?.msisdn })
		setShowSuccess(false)
		setShowError(false)
		setIsEditInfo(prev => !prev)
		// focusInputRef.current.focus()
	}

	const { mutate, data: updateUserInfo, isLoading } = useUpdateUserInfo(successUpdateInfoCb)
	function handleUpdateInfo() {
		mutate(infoData)
	}
	// TODO: save user localStorage old state
	function successUpdateInfoCb() {
		setIsEditInfo(false)
		const currentUser = getUserinfo()
		saveUserInfo({ ...currentUser, fullname: userData?.displayName, msisdn: userData?.msisdn })
	}

	return (
		<>
			<Row className="profilepage-content__title">
				{t('profile.personal_info.title')}
			</Row>
			<Row className="profilepage-content__body my-3">
				<Form className="baseinput-container">
					<Form.Group className="mb-3 base-input personal-info">
						<Form.Label>{t('profile.personal_info.name')}</Form.Label>
						<Form.Control
							disabled={!isEditInfo}
							type="text"
							value={infoData?.full_name}
							onChange={handleInfoChange}
							ref={focusInputRef}
							id="full_name"
						/>
						<img
							src={isEditInfo ? cancelEditInfoIcon : editInfoIcon}
							onClick={handleEditInfo}
							alt="Edit personal infomation"
						/>
					</Form.Group>
					<Form.Group className="mb-3 base-input personal-info">
						<Form.Label>{t('profile.personal_info.phone')}</Form.Label>
						<Form.Control
							disabled={true}
							type="phone"
							value={infoData?.phone}
							onChange={handleInfoChange}
							id="phone"
						/>
					</Form.Group>
					{/* <Form.Group
						className="mb-3 base-input personal-info"
						controlId="formBasicPassword"
					>
						<Form.Label>{t('profile.personal_info.referral')}</Form.Label>
						<Form.Control
							disabled={true}
							type="text"
							value={userData?.referralCode}
							ref={referralCodeRef}
						/>
						{!isEditInfo ? <img
							src={
								showSuccess
									? modalSuccessIcon
									: showError
										? modalErrorIcon
										: referralCopyIcon
							}
							onClick={handleCopyReferralCode}
							alt="Copy refferal code"
						/> : null}
					</Form.Group>
					{showSuccess || showError ? (
						<p className="error-text">{referralError}</p>
					) : null} */}
				</Form>
				{isEditInfo ? (
					<Button className="profile-confirm" onClick={handleUpdateInfo} disabled={prevInfoUser.current?.full_name === infoData?.full_name && prevInfoUser.current?.phone === infoData?.phone}>
						{t('confirm')}
						{isLoading ? (
							<Spinner animation="border" role="status"></Spinner>
						) : null}
					</Button>
				) : null}
			</Row>
			<UnitelModal data={updateUserInfo} />
		</>
	)
}

export default UserInfo
